<template>
  <div>
    <div class="flex p-4  border-t border-gray-100">
      <div class="mr-4 flex-shrink-0">
        <div class="rounded-full bg-primary-100 p-3 border border-primary-100">
          <ViewGridAddIcon class="h-6 w-6 text-primary-400"/>
        </div>
      </div>
      <div class="text-sm text-gray-500">
        <!--        <h4 class="text-md font-semibold font-medium text-gray-500 tracking-wider">Нет участников</h4>-->
        <slot><p>Нет данных</p></slot>
        <p class="mt-2">
          <ui-button-inline @click="$emit('btnClick', true)" class="text-xs">{{ btnText }}</ui-button-inline>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {ViewGridAddIcon} from "@heroicons/vue/outline";
import UiButtonInline from "@/components/ui/button/UiButtonInline";

export default {
  emits: ['btnClick'],
  components: {UiButtonInline, ViewGridAddIcon},
  props: {
    btnText: {
      default: 'Добавить'
    }
  }
}
</script>

<style scoped>

</style>